import { ChapterHeader, FadeUp } from "./Motion";

const Cell = ({ label, value, big, gold, span = "", testId }) => (
    <div className={`p-5 md:p-7 border border-white/10 bg-black ${span}`} data-testid={testId}>
        <div className="chapter-num">{label}</div>
        <div
            className={`font-mono mt-3 leading-none ${big ? "text-5xl md:text-7xl" : "text-2xl md:text-3xl"} ${
                gold ? "text-brand-gold" : "text-white"
            }`}
        >
            {value}
        </div>
    </div>
);

export default function WrestlingProfile({ content }) {
    const a = content.athlete;
    return (
        <section id="profile" className="relative py-20 md:py-32 border-t border-white/10">
            <div className="absolute right-0 top-1/3 w-[500px] h-[500px] radial-purple pointer-events-none" />
            <div className="max-w-[1600px] mx-auto px-5 md:px-10 relative z-10">
                <ChapterHeader num="03" kicker="Athletic Profile" title="Wrestling Profile" testId="chapter-profile" />

                <FadeUp>
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-px bg-white/10 border border-white/10">
                        <Cell label="Current Weight" value={`${a.currentWeight} lb`} big gold span="col-span-2 lg:col-span-2" testId="stat-currentweight" />
                        <Cell label="Projected" value={`${a.projectedWeight} lb`} big span="col-span-2 lg:col-span-2" testId="stat-projected" />
                        <Cell label="Height" value={a.height} span="col-span-1 lg:col-span-2" testId="stat-height" />
                        <Cell label="Class Of" value={a.graduationYear} testId="stat-grad" />
                        <Cell label="Varsity" value={`${a.varsityYears} Yrs`} testId="stat-varsity" />
                        <Cell label="Wrestling" value={`${a.yearsWrestling} Yrs`} testId="stat-years" />
                        <Cell label="High School" value="Corinth Holders" span="col-span-2 lg:col-span-2" testId="stat-hs" />
                        <Cell label="Club" value="Capital City WC" span="col-span-2" testId="stat-club" />
                        <Cell label="Location" value="Wendell, NC" span="col-span-2 lg:col-span-2" testId="stat-loc" />
                    </div>
                </FadeUp>

                {(a.hsRecord || a.nationalRecord) && (
                    <FadeUp delay={0.1}>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
                            {a.hsRecord && (
                                <div className="p-6 md:p-10 bg-black relative overflow-hidden" data-testid="stat-hsrecord">
                                    <div className="absolute inset-0 radial-purple opacity-50 pointer-events-none" />
                                    <div className="relative">
                                        <div className="chapter-num">High School Record</div>
                                        <div className="font-mono text-brand-gold text-6xl md:text-8xl mt-3 leading-none tracking-tighter">
                                            {a.hsRecord}
                                        </div>
                                        <div className="chapter-num mt-3 text-white/60">Corinth Holders HS · 132 lb</div>
                                    </div>
                                </div>
                            )}
                            {a.nationalRecord && (
                                <div className="p-6 md:p-10 bg-black relative overflow-hidden" data-testid="stat-nationalrecord">
                                    <div className="absolute inset-0 radial-gold opacity-30 pointer-events-none" />
                                    <div className="relative">
                                        <div className="chapter-num">
                                            {a.nationalRecordLabel || "National / Open Tournament Record"}
                                        </div>
                                        <div className="font-mono text-white text-6xl md:text-8xl mt-3 leading-none tracking-tighter">
                                            {a.nationalRecord}
                                        </div>
                                        <div className="chapter-num mt-3 text-white/60">Capital City WC · Open Bracket</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </FadeUp>
                )}

                <FadeUp delay={0.15}>
                    <div className="mt-10 border-t border-white/10 pt-8 grid grid-cols-1 md:grid-cols-12 gap-8">
                        <div className="md:col-span-4">
                            <div className="relative aspect-[3/4] overflow-hidden border border-white/10">
                                <img
                                    src={content.portraits.about}
                                    alt="Wrestling stance"
                                    className="w-full h-full object-cover"
                                    data-testid="profile-portrait"
                                />
                            </div>
                        </div>
                        <div className="md:col-span-8">
                            <div className="chapter-num">Field Notes</div>
                            <p className="editorial text-2xl md:text-3xl leading-snug mt-3 text-white/90">
                                “I would bring{" "}
                                <span className="text-brand-gold">consistency, coachability, a strong work ethic,</span>{" "}
                                good character, and a{" "}
                                <span className="editorial text-brand-gold">team-first</span> attitude to a college
                                wrestling room.”
                            </p>
                            <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-6 font-mono text-xs uppercase tracking-[0.2em]">
                                {["Discipline", "Coachability", "Work Ethic", "Consistency", "Character", "Team-First"].map(
                                    (t) => (
                                        <div key={t} className="flex items-center gap-2 border-b border-white/10 pb-2">
                                            <span className="w-1.5 h-1.5 bg-brand-gold" /> {t}
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
